module.exports = __webpack_public_path__ + "img/200-px.37b20654.png";